document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.video');
    const toggleBtn = document.querySelector('.video-sound-toggle');
    const mutedIcon = document.querySelector('.icon-speaker-muted');
    const unmutedIcon = document.querySelector('.icon-speaker-unmuted');

    if (!videos.length || !toggleBtn) return;
    const video = videos[videos.length - 1];

    function updateIcon() {
        if (video.muted) {
            mutedIcon.classList.remove('hidden');
            unmutedIcon.classList.remove('active');
        } else {
            mutedIcon.classList.add('hidden');
            unmutedIcon.classList.add('active');
        }
    }

    toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        video.muted = !video.muted;
        updateIcon();
    });

    updateIcon();
});
